/*
 * Copyright (c) 2016 Omnigon Communications, LLC. All rights reserved.
 *
 * This software is the confidential and proprietary information of Omnigon Communications, LLC
 * ("Confidential Information"). You shall not disclose such Confidential Information and shall access and use it only
 * in accordance with the terms of the license agreement you entered into with Omnigon Communications, LLC, its
 * subsidiaries, affiliates or authorized licensee. Unless required by applicable law or agreed to in writing, this
 * Confidential Information is provided on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the license agreement for the specific language governing permissions and limitations.
 */

import ArticleCard from 'scripts/models/api/cards/types/article';
import InfoCard from 'scripts/models/api/cards/types/info';
import PhotoCard from 'scripts/models/api/cards/types/photo';
import SocialCard from 'scripts/models/api/cards/types/social';
import TrendingCard from 'scripts/models/api/cards/types/trending';
import VideoCard from 'scripts/models/api/cards/types/video';
import LiveVideoCard from 'scripts/models/api/cards/types/live-video';
import LinkCard from 'scripts/models/api/cards/types/link';
import WinProbabilityCard from 'scripts/models/api/cards/types/win-probability';
import _ from 'lodash';

function getValidCard(obj) {
    let type = obj && obj.type;
    let Card = null;

    switch (type) {
        case 'articleCard': {
            Card = ArticleCard;
            break;
        }

        case 'infoCard': {
            Card = InfoCard;
            break;
        }
        case 'photoCard': {
            Card = PhotoCard;
            break;
        }
        case 'socialCard': {
            Card = SocialCard;
            break;
        }
        case 'trendingCard': {
            Card = TrendingCard;
            break;
        }
        case 'videoCard': {
            Card = VideoCard;
            break;
        }
        case 'liveVideo': {
            Card = LiveVideoCard;
            break;
        }
        case 'linkCard': {
            Card = LinkCard;
            break;
        }
        case 'winProbabilityCard': {
            Card = WinProbabilityCard;
            break;
        }
        default: {
            return null;
        }
    }

    let card = new Card(obj);

    return card.isValid ? card : null;
}

function getValidCards(arr) {
    let valid = [];
    if (arr && arr.length) {
        _.forEach(arr, (obj) => {
            let card = getValidCard(obj);

            card && valid.push(card);
        });
    }
    return valid;
}

export { getValidCard, getValidCards };
